import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';

function getModalStyle() {e
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}))


function CartModal(props) {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(true);
    const [body, setBody] = React.useState((
        <div style={modalStyle} className={classes.paper}>
            <h2 id="simple-modal-title">{props.title}</h2>
            <p id="simple-modal-description">
                {props.description}
                <Button
                    onClick={() => handleAddToCart()}
                    variant="contained"
                    color="primary"
                >
                    Dodaj v kosarico
                </Button>
                <Button
                        onClick={() => handleClose()}
                        variant="contained"
                        color="primary"
                    >
                        Nadaljuj z nakupom
                    </Button>
            </p>
        </div>
    ));

    React.useEffect(() => {
        console.log(props)
    }, []);

    const handleOpen = () => {
        setOpen(true);
        console.log('handle open')
    }

    const handleClose = () => {
        setOpen(false);
        console.log('handle close')
    }

    const handleAddToCart = () => {
        console.log('ad to cart')
        let cookie_value = getCookie('cart')
        if (cookie_value) {
            cookie_value = cookie_value + ',' + props.packageid
        } else {
            cookie_value = props.packageid
        }

        setCookie('cart', cookie_value, 365)
        console.log(cookie_value)
        setBody((
            <div style={modalStyle} className={classes.paper}>
                <h2 id="simple-modal-title">{props.title}</h2>
                <p id="simple-modal-description">
                    Izdelek je bil uspesno dodan v kosarico
                    <Button
                        onClick={() => {window.location.href = "/kosarica"}}
                        variant="contained"
                        color="primary"
                    >
                        Prikazi kosarico
                    </Button>
                    <Button
                        onClick={() => handleClose()}
                        variant="contained"
                        color="primary"
                    >
                        Nadaljuj z nakupom
                    </Button>
                </p>
            </div>
        ))
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            {body}
        </Modal>
    );

    function getCookie(c_name) {
        var c_value = document.cookie;
        var c_start = c_value.indexOf(" " + c_name + "=");
        if (c_start == -1) {
            c_start = c_value.indexOf(c_name + "=");
        }
        if (c_start == -1) {
            c_value = null;
        } else {
            c_start = c_value.indexOf("=", c_start) + 1;
            var c_end = c_value.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = c_value.length;
            }
            c_value = unescape(c_value.substring(c_start, c_end));
        }
        return c_value;
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;";
    }
}

window.addEventListener('load', function () {
    $('.btn__package_buy').click(function () {
        var title = $(this).attr('title');
        var description = $(this).attr('description');
        var packageid = $(this).attr('packageid');
        $('#cart_modal').remove()
        $("body").append('<div id="cart_modal"></div>');
        let element = document.getElementById("cart_modal")
        ReactDOM.render(<CartModal
            title={title}
            description={description}
            packageid={packageid}/>, element)
    })
});
